import { Injectable, EventEmitter } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { SelectionGenericService } from './selection-generic.service';
import { Moment } from 'moment';

@Injectable({
    providedIn: 'root'
})
export class FilterService {

    public selectedAttribute = [];
    public Consentimientos = new UntypedFormControl();
    public LeaveType = new UntypedFormControl();
    public LeaveSelectionMoreFilterForm: UntypedFormGroup;
    public LeaveDaysFrom = new UntypedFormControl();
    public LeaveDaysTo = new UntypedFormControl();
    public LeaveEndOfPeriodDaysFrom = new UntypedFormControl();
    public LeaveEndOfPeriodDaysTo = new UntypedFormControl();
    public LeaveInPeriodDaysFrom = new UntypedFormControl();
    public LeaveInPeriodDaysTo = new UntypedFormControl();
    public LaborDaysFrom = new UntypedFormControl();
    public LaborDaysTo = new UntypedFormControl();
    public LaborEndOfPeriodDaysFrom = new UntypedFormControl();
    public LaborEndOfPeriodDaysTo = new UntypedFormControl();
    public LaborInPeriodDaysFrom = new UntypedFormControl();
    public LaborInPeriodDaysTo = new UntypedFormControl();
    public LeaveCommunicationGapDaysFrom = new UntypedFormControl();
    public LeaveCommunicationGapDaysTo = new UntypedFormControl();
    public DiagnosisFrom = new UntypedFormControl();
    public DiagnosisTo = new UntypedFormControl();

    public CommunicationDateFrom = new UntypedFormControl();
    public CommunicationDateTo = new UntypedFormControl();
    public DischargeDateFrom = new UntypedFormControl();
    public DischargeDateTo = new UntypedFormControl();
    public NewLeaveDateFrom = new UntypedFormControl();
    public NewLeaveDateTo = new UntypedFormControl();

    public FromDate: Moment = null;
    public ToDate: Moment = null;
    public loggedDoctorName: string;

    // Additional Actuation Filters
    public CommonDateFrom = new UntypedFormControl();
    public CommonDateTo = new UntypedFormControl();
    public FechaRevisionDateFrom = new UntypedFormControl();
    public FechaRevisionDateTo = new UntypedFormControl();
    public UsuarioList$: any[];
    public CoordinadorList$: any[];
    public GestorList$: any[];    
    public PoblacionList: any[];    
    public Usuario: string;
    public Coordinador: string;
    public EmpresaCoordinador: string;
    public Gestor: string;
    public Revisadas: boolean;
    public ConComentarios: boolean;
    public ConOrdenes: boolean;
    public IsConceptosFacturables: boolean;
    public FacturacionRadioButton: string;
    public FacturacionFraCentro: string;
    public ActuationSelectedAttribute = [];
    public PeriodoDeBajaDateFrom = new UntypedFormControl();
    public PeriodoDeBajaDateTo = new UntypedFormControl();
    public ActuationLeaveType = new UntypedFormControl();
    public IsRevisor: boolean;
    // Main Actuation Filters
    public MainCommonDateFrom = new UntypedFormControl();
    public MainCommonDateTo = new UntypedFormControl();
    public DoctorList$: any[];
    public radioSelected: string;
    public ActiveLeaves: boolean;    
    public Orden: string;
    public Autor: string;

    // more task filters
    public FPAFrom = new UntypedFormControl(null);
    public FPATo = new UntypedFormControl(null);
    public DiasFrom = new UntypedFormControl(null);
    public DiasTo = new UntypedFormControl(null);    
    public TaskGestor = new UntypedFormControl(null);
    public TaskCoordinador = new UntypedFormControl(null);

    public OnFiltersCleard = new EventEmitter();

    constructor(public selectionService: SelectionGenericService, private formBuilder: UntypedFormBuilder) {
        this.LeaveSelectionMoreFilterForm = this.formBuilder.group({
            Doctor: [null],
            Weekday: [null],
            WeekdayCount: [null, [Validators.min(0), Validators.max(100)]],
            NoDiagnosis: [false],
            NoDiagnosisReason: null,
            PsychosocialRisk: null,
            Gestor: [null],
            Coordinador: [null]
        });
    }

    public clearEmployeeMoreFilters(): void {
        this.selectedAttribute = [];
        this.selectionService.resetEmployeeMoreFilterValues();
    }

    public clearLeaveMoreFilters(): void {
        this.selectedAttribute = [];
        this.Consentimientos.setValue([]);
        this.LeaveType.setValue([]);
        this.LeaveSelectionMoreFilterForm.patchValue({
            Doctor: 0,
            Weekday: null,
            WeekdayCount: null,
            NoDiagnosis: false,
            NoDiagnosisReason: [],
            PsychosocialRisk: [],
            Gestor: [],
            Coordinador: []  
        });
        this.LeaveSelectionMoreFilterForm.get('NoDiagnosis').setValue(false);
        this.LeaveSelectionMoreFilterForm.get('NoDiagnosisReason').setValidators([]);
        this.LeaveSelectionMoreFilterForm.get('NoDiagnosisReason').setErrors(null)
     
        this.LeaveDaysFrom.setValue(null);
        this.LeaveDaysTo.setValue(null);
        this.LeaveEndOfPeriodDaysFrom.setValue(null);
        this.LeaveEndOfPeriodDaysTo.setValue(null);
        this.LeaveInPeriodDaysFrom.setValue(null);
        this.LeaveInPeriodDaysTo.setValue(null);
        this.LaborDaysFrom.setValue(null);
        this.LaborDaysTo.setValue(null);
        this.LaborEndOfPeriodDaysFrom.setValue(null);
        this.LaborEndOfPeriodDaysTo.setValue(null);
        this.LaborInPeriodDaysFrom.setValue(null);
        this.LaborInPeriodDaysTo.setValue(null);
        this.LeaveCommunicationGapDaysFrom.setValue(null);
        this.LeaveCommunicationGapDaysTo.setValue(null);
 
        this.DiagnosisFrom.setValue(null);
        this.DiagnosisTo.setValue(null);
        
        this.CommunicationDateFrom.setValue(null);
        this.CommunicationDateTo.setValue(null);
        this.DischargeDateFrom.setValue(null);
        this.DischargeDateTo.setValue(null);
        this.NewLeaveDateFrom.setValue(null);
        this.NewLeaveDateTo.setValue(null);

        this.OnFiltersCleard.emit(true);
    }

    public clearActuationMoreFilters(): void {
        this.CommonDateFrom.setValue(null);
        this.CommonDateTo.setValue(null);
        this.FechaRevisionDateFrom.setValue(null);
        this.FechaRevisionDateTo.setValue(null);
        this.Usuario = '';
        this.Coordinador = '';
        this.EmpresaCoordinador = '';
        this.Gestor = '';
        this.Revisadas = false;
        this.ConComentarios = false;
        this.ConOrdenes = false;
        this.IsConceptosFacturables = false;
        this.FacturacionRadioButton = '';
        this.FacturacionFraCentro = '';
        this.ActuationSelectedAttribute = [];
        this.PeriodoDeBajaDateFrom.setValue(null);
        this.PeriodoDeBajaDateTo.setValue(null);
        this.ActuationLeaveType.setValue(null);        
        this.selectionService.resetActuationMoreFilterValues();
        this.OnFiltersCleard.emit(true);
    }

    public clearTaskMoreFilters(): void {
        this.FPAFrom.setValue(null);
        this.FPATo.setValue(null);
        this.DiasFrom.setValue(null);
        this.DiasTo.setValue(null);        
        this.TaskCoordinador.setValue(null);
        this.TaskGestor.setValue(null);
        this.selectionService.resetTaskMoreFilterValues();
        this.LeaveType.setValue([]);
        this.OnFiltersCleard.emit(true);
    }

}
